import { storage } from "./firebase";
import { saveDocument } from "./firestore";
import { getCryptoRandomString } from "../utils/CryptoRandomString";

let userLogoCache = [];
let clientLogoCache = [];

// Upload File
export const uploadDocument = (account, file, projectId, finished, error) => {
  const fileId = getCryptoRandomString(16);

  const extension = fileNameToExtension(file.name);

  const path = `accounts/${account}/projects/${projectId}/${fileId}${extension}`;
  var storageRef = storage.ref();
  var ref = storageRef.child(path);
  ref.put(file).then(snap => {
    snap.ref.getDownloadURL().then(url => {
      saveDocument(
        account,
        projectId,
        file.name,
        url,
        path,
        file.type,
        doc => {
          finished(snap, url, doc);
        },
        err => error(err)
      );
    });
  });
};

export const uploadClientLogo = (account, file, clientId, finished) => {
  const path = `accounts/${account}/clients/${clientId}`;
  var storageRef = storage.ref();
  var ref = storageRef.child(path);
  ref.put(file).then(snap => {
    finished(path);
  });
};

export const getClientLogoUrl = (account, clientId, success, error) => {
  if (clientLogoCache[clientId]) {
    success(clientLogoCache[clientId]);
    return;
  }

  const path = `accounts/${account}/clients/${clientId}`;
  var storageRef = storage.ref();
  var ref = storageRef.child(path);

  ref
    .getDownloadURL()
    .then(url => {
      clientLogoCache[clientId] = url;
      success(url);
    })
    .catch(error);
};

export const getUserAvatarUrl = (userId, success, error) => {
  if (userLogoCache[userId]) {
    success(userLogoCache[userId]);
    return;
  }

  const path = `users/${userId}`;
  var storageRef = storage.ref();
  var ref = storageRef.child(path);
  ref
    .getDownloadURL()
    .then(url => {
      userLogoCache[userId] = url;
      success(url);
    })
    .catch(error);
};

export const pathToFileName = path => path.replace(/^.*[\\/]/, ""); //  (/^.*[\\/]/, "")
export const fileNameToExtension = fileName =>
  /(?:\.([^.]+))?$/.exec(fileName)[0];



// WEBPACK FOOTER //
// ./src/firebase/storage.js